var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-up-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0031 10.0605L8.5478 16.5157L7.4873 15.4553L13.9418 9H8.25305V7.5H16.5031V15.75H15.0031V10.0605Z",
    fill: "#101820"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUpArrow);
export default __webpack_public_path__ + "static/media/right-up-arrow.fc7aebc58ffccec29419cde2d6ec5590.svg";
export { ForwardRef as ReactComponent };